export const state = () => ({
  regions: [
    {
      code: '77',
      licence_plates: [77, 97, 99, 177, 197, 199, 777, 799, 977],
      label: 'г. Москва',
      string: 'Москва'
    },
    {
      code: '50',
      licence_plates: [50, 90, 150, 190, 750, 790],
      label: 'Московская область',
      string: 'Московской области'
    },
    {
      code: '78',
      licence_plates: [78, 98, 178, 198],
      label: 'г. Санкт-Петербург',
      string: 'Санкт-Петербург'
    },
    {
      code: '47',
      label: 'Ленинградская область',
      string: 'Ленинградской области'
    },
    {
      code: '22',
      label: 'Алтайский край',
      string: 'Алтайском крае'
    },
    {
      code: '28',
      label: 'Амурская область',
      string: 'Амурской области'
    },
    {
      code: '29',
      label: 'Архангельская область',
      string: 'Архангельской области'
    },
    {
      code: '30',
      label: 'Астраханская область',
      string: 'Астраханской области'
    },
    {
      code: '31',
      label: 'Белгородская область',
      string: 'Белгородской области'
    },
    {
      code: '32',
      label: 'Брянская область',
      string: 'Брянской области'
    },
    {
      code: '33',
      label: 'Владимирская область',
      string: 'Владимирской области'
    },
    {
      code: '34',
      label: 'Волгоградская область',
      string: 'Волгоградской области'
    },
    {
      code: '35',
      label: 'Вологодская область',
      string: 'Вологодской области'
    },
    {
      code: '36',
      label: 'Воронежская область',
      string: 'Воронежской области'
    },
    {
      code: '80',
      label: 'Донецкая народная республика',
      string: 'Донецкая народная республика'
    },
    {
      code: '79',
      label: 'Еврейская автономная область',
      string: 'Еврейской автономной области'
    },
    {
      code: '75',
      licence_plates: [75, 80],
      label: 'Забайкальский край',
      string: 'Забайкальском крае'
    },
    {
      code: '37',
      label: 'Ивановская область',
      string: 'Ивановской области'
    },
    {
      code: '38',
      licence_plates: [38, 85, 138],
      label: 'Иркутская область',
      string: 'Иркутской области'
    },
    {
      code: '07',
      label: 'Кабардино-Балкарская Республика',
      string: 'Кабардино-Балкарской Республике'
    },
    {
      code: '39',
      licence_plates: [39, 91],
      label: 'Калининградская область',
      string: 'Калининградской области'
    },
    {
      code: '40',
      label: 'Калужская область',
      string: 'Калужской области'
    },
    {
      code: '41',
      label: 'Камчатский край',
      string: 'Камчатском крае'
    },
    {
      code: '09',
      label: 'Карачаево-Черкесская Республика',
      string: 'Карачаево-Черкесской Республике'
    },
    {
      code: '42',
      label: 'Кемеровская область',
      string: 'Кемеровской области'
    },
    {
      code: '43',
      label: 'Кировская область',
      string: 'Кировской области'
    },
    {
      code: '44',
      label: 'Костромская область',
      string: 'Костромской области'
    },
    {
      code: '23',
      licence_plates: [23, 93, 123, 193],
      label: 'Краснодарский край',
      string: 'Краснодарском крае'
    },
    {
      code: '24',
      licence_plates: [24, 84, 88, 124],
      label: 'Красноярский край',
      string: 'Красноярском крае'
    },
    {
      code: '45',
      label: 'Курганская область',
      string: 'Курганской области'
    },
    {
      code: '46',
      label: 'Курская область',
      string: 'Курской области'
    },
    {
      code: '48',
      label: 'Липецкая область',
      string: 'Липецкой области'
    },
    {
      code: '81',
      label: 'Луганская народная республика',
      string: 'Луганская народная республика'
    },
    {
      code: '49',
      label: 'Магаданская область',
      string: 'Магаданской области'
    },
    {
      code: '51',
      label: 'Мурманская область',
      string: 'Мурманской области'
    },
    {
      code: '83',
      label: 'Ненецкий автономный округ',
      string: 'Ненецком автономном округе'
    },
    {
      code: '52',
      label: 'Нижегородская область',
      string: 'Нижегородской области'
    },
    {
      code: '53',
      label: 'Новгородская область',
      string: 'Новгородской области'
    },
    {
      code: '54',
      label: 'Новосибирская область',
      string: 'Новосибирской области'
    },
    {
      code: '55',
      label: 'Омская область',
      string: 'Омской области'
    },
    {
      code: '56',
      label: 'Оренбургская область',
      string: 'Оренбургской области'
    },
    {
      code: '57',
      label: 'Орловская область',
      string: 'Орловской области'
    },
    {
      code: '58',
      label: 'Пензенская область',
      string: 'Пензенской области'
    },
    {
      code: '59',
      licence_plates: [59, 81, 159],
      label: 'Пермский край',
      string: 'Пермском крае'
    },
    {
      code: '25',
      label: 'Приморский край',
      string: 'Приморском крае'
    },
    {
      code: '60',
      label: 'Псковская область',
      string: 'Псковской области'
    },
    {
      code: '01',
      label: 'Республика Адыгея',
      string: 'Республике Адыгея'
    },
    {
      code: '04',
      label: 'Республика Алтай',
      string: 'Республике Алтай'
    },
    {
      code: '02',
      label: 'Республика Башкортостан',
      string: 'Республике Башкортостан'
    },
    {
      code: '03',
      label: 'Республика Бурятия',
      string: 'Республике Бурятия'
    },
    {
      code: '05',
      label: 'Республика Дагестан',
      string: 'Республике Дагестан'
    },
    {
      code: '06',
      label: 'Республика Ингушетия',
      string: 'Республике Ингушетия'
    },
    {
      code: '08',
      label: 'Республика Калмыкия',
      string: 'Республике Калмыкия'
    },
    {
      code: '10',
      label: 'Республика Карелия',
      string: 'Республике Карелия'
    },
    {
      code: '11',
      label: 'Республика Коми',
      string: 'Республике Коми'
    },
    {
      code: '82',
      label: 'Республика Крым и Севастополь',
      string: 'Республика Крым и Севастополь'
    },
    {
      code: '12',
      label: 'Республика Марий Эл',
      string: 'Республике Марий Эл'
    },
    {
      code: '13',
      label: 'Республика Мордовия',
      string: 'Республике Мордовия'
    },
    {
      code: '14',
      label: 'Республика Саха',
      string: 'Республике Саха'
    },
    {
      code: '15',
      label: 'Республика Северная Осетия - Алания',
      string: 'Республике Северная Осетия'
    },
    {
      code: '16',
      label: 'Республика Татарстан',
      string: 'Республике Татарстан'
    },
    {
      code: '17',
      label: 'Республика Тыва',
      string: 'Республике Тыва'
    },
    {
      code: '19',
      label: 'Республика Хакасия',
      string: 'Республике Хакасия'
    },
    {
      code: '61',
      label: 'Ростовская область',
      string: 'Ростовской области'
    },
    {
      code: '62',
      label: 'Рязанская область',
      string: 'Рязанской области'
    },
    {
      code: '63',
      label: 'Самарская область',
      string: 'Самарской области'
    },
    {
      code: '64',
      label: 'Саратовская область',
      string: 'Саратовской области'
    },
    {
      code: '65',
      label: 'Сахалинская область',
      string: 'Сахалинской области'
    },
    {
      code: '66',
      licence_plates: [66, 96, 196],
      label: 'Свердловская область',
      string: 'Свердловской области'
    },
    {
      code: '92',
      label: 'Севастополь',
      string: 'Севастополе'
    },
    {
      code: '67',
      label: 'Смоленская область',
      string: 'Смоленской области'
    },
    {
      code: '26',
      label: 'Ставропольский край',
      string: 'Ставропольском крае'
    },
    {
      code: '68',
      label: 'Тамбовская область',
      string: 'Тамбовской области'
    },
    {
      code: '69',
      label: 'Тверская область',
      string: 'Тверской области'
    },
    {
      code: '70',
      label: 'Томская область',
      string: 'Томской области'
    },
    {
      code: '71',
      label: 'Тульская область',
      string: 'Тульской области'
    },
    {
      code: '72',
      label: 'Тюменская область',
      string: 'Тюменской области'
    },
    {
      code: '18',
      label: 'Удмуртская Республика',
      string: 'Удмуртской Республике'
    },
    {
      code: '73',
      licence_plates: [73, 173, 82],
      label: 'Ульяновская область',
      string: 'Ульяновской области'
    },
    {
      code: '27',
      label: 'Хабаровский край',
      string: 'Хабаровском крае'
    },
    {
      code: '86',
      label: 'Ханты-Мансийский автономный округ - Югра',
      string: 'Ханты-Мансийском автономном округе'
    },
    {
      code: '74',
      label: 'Челябинская область',
      string: 'Челябинской области'
    },
    {
      code: '20',
      label: 'Чеченская Республика',
      string: 'Чеченской Республике'
    },
    {
      code: '21',
      label: 'Чувашская Республика - Чувашия',
      string: 'Чувашской Республике'
    },
    {
      code: '87',
      label: 'Чукотский автономный округ',
      string: 'Чукотском автономном округе'
    },
    {
      code: '89',
      label: 'Ямало-Ненецкий автономный округ',
      string: 'Ямало-Ненецком автономном округе'
    },
    {
      code: '76',
      label: 'Ярославская область',
      string: 'Ярославской области'
    }
  ]
})

export const getters = {
  getCode: _state => (code) => {
    let regionId = code
    if (regionId.length === 1) {
      regionId = '0' + regionId
    }
    return regionId.toString()
  },

  findByCode: (state, getters) => (code) => {
    const id = getters.getCode(code)
    return state.regions.find(el => el.code === id) || {}
  },

  getRegionLabelByCode: (state) => (code) => {
    return state.regions.find(region => region.code === code)?.label
  },

  getRegionIdByLicencePlate: (state, getters) => (licencePlate) => {
    if (!licencePlate) return null
    licencePlate = licencePlate.replaceAll(' ', '')
    let regionFromLicencePlate = licencePlate.slice(-2)

    let suggestedRegion = state.regions.find(region => {
      if (region.licence_plates) {
        return region.licence_plates.includes(+regionFromLicencePlate)
      } else {
        return region.code === regionFromLicencePlate
      }
    }) || null

    return suggestedRegion?.code || null
  },

  getList: (state) => {
    return state.regions.slice().sort((a, b) => a.label > b.label ? 1 : -1)
  },

  searchByLabel: (state, getters) => (label) => {
    return getters.getList.filter(item => item.label.toLowerCase().includes(label.toLowerCase()))
  },

  getSubList: (state, getters) => (code) => {
    const regionList = getters.getList
    const start = (+code + 10) % regionList.length
    const end = (start + 12) % regionList.length
    return getters.getList.slice(start, end)
  }
}

export default {
  namespaced: true,
  state,
  getters
}
